import { Controller } from "@hotwired/stimulus"
import { ping } from "../lib/ping"

// Counts a paid Featured block as seen once it's half on screen, once per page view, so partners'
// reports can say how often their card was shown. Anonymous, like every other ping.
export default class extends Controller {
  static values = { ids: String }

  connect() {
    if (!this.idsValue || !("IntersectionObserver" in window)) return

    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return

      ping("promo_impression", { event_ids: this.idsValue })
      this.disconnect()
    }, { threshold: 0.5 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
    this.observer = null
  }
}
